import { EVENT_PROPERTIES_VALUES } from "../types/Amplitude";

export const EMPTY_CART_SHOP_LINKS = [
  {
    product: "Restore",
    action: EVENT_PROPERTIES_VALUES.Shop_Restore_Button_Clicked,
    link: "/restore",
  },
  {
    product: "Rest Family",
    action: EVENT_PROPERTIES_VALUES.Shop_Rest_Family_Button_Clicked,
    link: "/rest-family",
  },
];
